import React, { Fragment, useState } from 'react';
import { toast } from 'react-toastify';
import Button from 'react-bootstrap-button-loader';
import axios from 'axios';
import FormularioProducto from './formularioProducto';
import {
    createEmptyImageSlots,
    applySlotPayload,
    buildElemtsPayloadFromSlots
} from './imageSlots';

const AgregarProducto = (props) => {
    const [imagenes, setImagenes] = useState(createEmptyImageSlots());
    const [look, setLook] = useState(false);
    const [datos, setDatos] = useState({
        sku:'',
        name:'',
        description:'',
        short_description:'',
        price:'',
        qty:'',
        is_in_stock:'',
        categoria:'',
        subcategoria:'',
        marca:'',
        material:'',
        color:'',
        acabado:'',
        medida:'',
        tipo:'',
        funcionamiento:'',
        potencia:'',
        uso:'',
        largo:'',
        largo_maximo:'',
        ancho:'',
        altura:'',
        diametro:'',
        dias_pedido:'',
        unidad:'',
        contenido:'',
        oferta:'',
        destacado:false,
        mas_buscado:false,
        nuevo:false,
        visible:true,
        sobrepedido:false,
        dias_pedido:'',
        sustitutos:[],
        MIN_UNIDAD:'',
        MAX_UNIDAD:'',
        MIN_UNIDAD_QTY:'',
        NIVEL_1:false,
        NIVEL_2:false,
        PRECIO_ACTIVO:false
    });
    const [url] = useState(    /*  'http://localhost:3000'     */        'https://cms.lprefacciones.mx'     );

    const handleImagenSlotChange = (order, payload = {}) => {
        setImagenes(prev => applySlotPayload(prev, order, payload));
    }

    const guardarProducto = () => {
        const elemtsPayload = buildElemtsPayloadFromSlots(imagenes);
        axios.request({
            method: 'POST',
            url: url + '/p_productos',
            data: { elemts: elemtsPayload, datos },
            withCredentials: true
        })
        .then(() => {
            props.setPag_agregar(false);
        })
        .catch(error => {
            console.log(error);
            const message = error?.response?.data?.resultado || error?.response?.data?.detalle || error?.message || 'No se pudo guardar el producto.';
            toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT });
            setLook(false);
        });
    }

    const submitFormulario = () => {
        if (!datos.sku || datos.sku.length === 0) {
            toast.warn('El campo SKU no puede estar vacío.', { position: toast.POSITION.BOTTOM_RIGHT });
            return;
        }
        const unidadSeleccionada = String(datos.MAX_UNIDAD || datos.MIN_UNIDAD || datos.unidad || '').trim();
        if (!unidadSeleccionada) {
            toast.warn('El campo Unidad es obligatorio.', { position: toast.POSITION.BOTTOM_RIGHT });
            return;
        }
        setLook(true);
        fetch('/p_producto_unico', {
            method: 'POST',
            body: JSON.stringify({ CODIGO_REFERENCIA: datos.sku }),
            headers: { 'Content-Type': 'application/json' }
        })
        .then(res => res.json())
        .then(res => {
            if (res.RESULT === 0) {
                guardarProducto();
            } else {
                setLook(false);
                toast.warn('El SKU debe ser único.', { position: toast.POSITION.BOTTOM_RIGHT });
            }
        })
        .catch(err => {
            console.log('Error: ' + err);
            setLook(false);
        });
    }

    return (
        <Fragment>
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-header">
                        <button className="btn btn-outline-light-2x txt-dark mb-4" onClick={()=> props.setPag_agregar(false)}>
                            <i className="icofont icofont-arrow-left"/>Regresar
                        </button>
                        <hr className="mt-2"/>
                        <div className="col-12">
                            <FormularioProducto
                                datos={datos}
                                setDatos={setDatos}
                                imagenes={imagenes}
                                onImagenChange={handleImagenSlotChange}
                            />
                        </div>
                        <div className="col-md-12 mt-2">
                            <div className="text-right">
                                <Button className='btn-lg mr-4' onClick={submitFormulario} loading={look}>
                                    Guardar
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
 
export default AgregarProducto;
